import { Component, input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-tab',
  styleUrl: './tab.component.scss',
  template: `<ng-template #templateRef><ng-content /></ng-template>`,
})
export class TabComponent {
  @ViewChild('templateRef', { static: true }) content!: TemplateRef<unknown>;
  label = input.required<string>();
  disabled = input(false);
}
